import React, {useState} from 'react';
import './styles.css'
import tytErp from './LogosProductos/tyterp.png';
import tytNomina from './LogosProductos/tytnomina.png';
import tytCfdi from './LogosProductos/tytcfdi.png';
import {Link} from 'react-router-dom';
import { useHistory } from 'react-router-dom';


export default function NuestrosProductos(props){

    let history = useHistory();


    return(<>
    <div className="contenedorProductos">

        <div className='cTituloProductosInicio'>
            <h2>
                NUESTROS PRODUCTOS
            </h2>
            </div>

        <div className='filasProductos'>

            <div className='contenedorCardProductos'>
                <Link to='/tterp'>
                    <img src={tytErp} className='contenedorImagenProducto' />
                </Link>
                <div className='tituloProducto'>T&T ERP
                </div>
                <div className='cButtonConoceMas' onClick = {()=> {
                    history.push('/tterp')
                }}>
                    Conoce más
                </div>
            </div>


            <div className='contenedorCardProductos'>
                <Link to='/ttnomina'>
                    <img src={tytNomina} className='contenedorImagenProducto' />
                </Link>
                <div className='tituloProducto'>T&T NÓMINA
                </div>
                <div className='cButtonConoceMas' onClick = {()=> {
                    history.push('/ttnomina')
                }}>
                    Conoce más
                </div>
            </div>

            <div className='contenedorCardProductos'>
            <Link to='/ttcfdi'>
                    <img src={tytCfdi} className='contenedorImagenProducto' />
                </Link>
                
                <div className='tituloProducto'>T&T CFDI
                </div>
                <div className='cButtonConoceMas' onClick = {()=> {
                    history.push('/ttcfdi')
                }}>
                    Conoce más
                </div>
            </div>

        </div>
    </div>
    </>)
}
